/* =================================================================
   Everty Promo Banner
   1. Enddatum "heute + N Tage" wird im Browser gerechnet, damit ein
      gecachtes HTML nie ein falsches Datum zeigt.
   2. Der Rabatt-Prozentsatz wird aus der Buy Box gelesen (die
      gerenderten Badges der Mengen-Boxen), damit Banner und Box
      niemals auseinanderlaufen.
   Kein rAF: in versteckten Tabs friert rAF ein, setInterval rechnet
   dagegen bei jedem Tick neu aus der Systemzeit und korrigiert sich.
   ================================================================= */
(function () {
  if (window.__evertyPromoBanner) return;
  window.__evertyPromoBanner = true;

  var MONTHS = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  var MONTHS_SHORT = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'];
  var WEEKDAYS = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var WEEKDAYS_SHORT = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  /* Enddatum: heute + offset Tage, jeweils bis zum Tagesende. */
  function endDate(offsetDays) {
    var d = new Date();
    d.setDate(d.getDate() + offsetDays);
    d.setHours(23, 59, 59, 999);
    return d;
  }

  function formatDate(d, format) {
    var day = d.getDate();
    var month = d.getMonth();
    var year = d.getFullYear();

    switch (format) {
      case 'long_year':
        return day + '. ' + MONTHS[month] + ' ' + year;
      case 'short':
        return pad(day) + '.' + pad(month + 1) + '.';
      case 'short_year':
        return pad(day) + '.' + pad(month + 1) + '.' + year;
      case 'weekday':
        return WEEKDAYS[d.getDay()] + ', ' + day + '. ' + MONTHS[month];
      case 'weekday_short':
        return WEEKDAYS_SHORT[d.getDay()] + ', ' + pad(day) + '.' + pad(month + 1) + '.';
      case 'month_short':
        return day + '. ' + MONTHS_SHORT[month];
      default:
        return day + '. ' + MONTHS[month];
    }
  }

  function formatCountdown(ms) {
    if (ms < 0) ms = 0;
    var total = Math.floor(ms / 1000);
    var days = Math.floor(total / 86400);
    var hours = Math.floor((total % 86400) / 3600);
    var minutes = Math.floor((total % 3600) / 60);
    var seconds = total % 60;
    var clock = pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
    if (days > 0) return days + (days === 1 ? ' Tag ' : ' Tage ') + clock;
    return clock;
  }

  /* ---------- Rabatt aus der Buy Box ---------- */

  function pctFromNode(node) {
    if (!node) return null;
    var digits = (node.textContent || '').replace(/[^0-9]/g, '');
    if (!digits) return null;
    var n = parseInt(digits, 10);
    return isNaN(n) || n <= 0 ? null : n;
  }

  function buyBox() {
    return document.querySelector('[data-energie-pm]');
  }

  function readPct(source) {
    var pm = buyBox();
    if (!pm) return null;

    if (source === 'auto_selected') {
      var active =
        pm.querySelector('.epm__box--active .epm__box-badge') ||
        pm.querySelector('[data-epm-box][aria-pressed="true"] .epm__box-badge');
      return pctFromNode(active);
    }

    var best = null;
    var badges = pm.querySelectorAll('[data-epm-box] .epm__box-badge');
    for (var i = 0; i < badges.length; i++) {
      var n = pctFromNode(badges[i]);
      if (n !== null && (best === null || n > best)) best = n;
    }
    return best;
  }

  /* ---------- Ein Banner ---------- */

  function initBanner(el) {
    if (el.dataset.evpInited === '1') return;
    el.dataset.evpInited = '1';

    var offsetDays = parseInt(el.getAttribute('data-days'), 10);
    if (isNaN(offsetDays)) offsetDays = 3;

    var format = el.getAttribute('data-date-format') || 'long';
    var pctSource = el.getAttribute('data-pct-source') || 'auto_max';
    var dateNodes = el.querySelectorAll('[data-everty-promo-date]');
    var cdNodes = el.querySelectorAll('[data-everty-promo-cd]');
    var wantsCountdown = cdNodes.length > 0;
    var pctNodes = el.querySelectorAll('[data-everty-promo-pct]');

    var lastDate = '';
    var lastPct = null;

    function paintDate() {
      var end = endDate(offsetDays);
      var text = formatDate(end, format);
      if (text !== lastDate) {
        lastDate = text;
        for (var i = 0; i < dateNodes.length; i++) dateNodes[i].textContent = text;
      }
      return end;
    }

    function paintCountdown(end) {
      if (!cdNodes.length) return;
      var text = formatCountdown(end.getTime() - Date.now());
      for (var i = 0; i < cdNodes.length; i++) cdNodes[i].textContent = text;
    }

    function paintPct() {
      if (!pctNodes.length || pctSource === 'fixed') return;
      var n = readPct(pctSource);
      if (n === null || n === lastPct) return;
      lastPct = n;
      for (var i = 0; i < pctNodes.length; i++) pctNodes[i].textContent = n + '%';
    }

    var end = paintDate();
    paintCountdown(end);
    paintPct();
    el.removeAttribute('data-evp-pending');

    /* Timer stoppen, sobald der Knoten aus dem DOM fällt (Theme-Editor
       rendert Sections neu, sonst laufen tote Intervalle weiter). */
    function every(ms, fn) {
      var id = setInterval(function () {
        if (!el.isConnected) {
          clearInterval(id);
          return;
        }
        fn();
      }, ms);
    }

    if (wantsCountdown) {
      every(1000, function () {
        paintCountdown(paintDate());
      });
    } else {
      /* Ohne Countdown reicht ein Blick pro Minute für den Tageswechsel. */
      every(60000, paintDate);
    }

    if (pctSource === 'auto_selected' || pctSource === 'auto_max') {
      var pm = buyBox();
      var boxes = pm && pm.querySelector('[data-epm-boxes]');
      if (boxes && window.MutationObserver) {
        var mo = new MutationObserver(function () {
          if (!el.isConnected) {
            mo.disconnect();
            return;
          }
          paintPct();
        });
        mo.observe(boxes, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['class', 'aria-pressed']
        });
      }
    }
  }

  function initAll() {
    var nodes = document.querySelectorAll('[data-everty-promo]');
    for (var i = 0; i < nodes.length; i++) initBanner(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme-Editor: Sections werden neu gerendert, Banner erneut initialisieren. */
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', initAll);
})();
